
/*
  UXS — INTERACTIVE DIALOGUE V2
  VOICE 001 / 29 AUDIO MASTER

  Apertura V4 -> Puente V2
  -> 2 preguntas cerradas
  -> 1 pregunta profunda
  -> HABLAR

  Mantiene VOICE 002 y el vocoder intactos.
*/

(function () {
  "use strict";

  function initialize() {
    const main = document.getElementById("uxs-main");
    const subtitle = document.getElementById(
      "uxs-voice001-subtitles"
    );
    const recording = document.getElementById(
      "uxs-recording"
    );

    if (!main || !subtitle || !recording) return;
    if (main.dataset.questionsReady === "true") return;

    main.dataset.questionsReady = "true";
    main.classList.add("uxs-questions-pending");

    // ==================================
    // AUDIO / SHOPIFY CDN
    // ==================================
    // Todos los MP3 deben haberse subido
    // conservando sus nombres del ZIP.
    //
    // No se necesitan carpetas dentro de
    // Shopify: Archivos usa una misma ruta.

    const CDN =
      "https://cdn.shopify.com/s/files/1/0899/2040/5871/files/";

    function audioURL(filename) {
      return CDN + encodeURIComponent(filename);
    }

    // ==================================
    // CAMINOS Y PREGUNTAS
    // ==================================

    const paths = {
      tiempo: {
        questions: [
          {
            text:
              "¿ÚLTIMAMENTE SIENTES QUE EL TIEMPO PASA MUY RÁPIDO?",
            file: "TIEMPO_01_FINAL.mp3",
            answers: [
              "DEMASIADO RÁPIDO",
              "A VECES SE DETIENE",
              "YA NI SÉ"
            ]
          },
          {
            text:
              "¿SI PUDIERAS DETENERLO UN MOMENTO, LO HARÍAS?",
            file: "TIEMPO_02_FINAL.mp3",
            answers: [
              "SIN PENSARLO",
              "NO CREO",
              "DEPENDE DEL MOMENTO"
            ]
          }
        ],

        deep: [
          "¿QUÉ MOMENTO TE GUSTARÍA QUE HUBIERA DURADO UN POCO MÁS?",
          "¿QUÉ RECUERDO TIENES MIEDO DE OLVIDAR?",
          "¿CUÁNDO FUE LA ÚLTIMA VEZ QUE SENTISTE QUE EL TIEMPO SE DETUVO?",
          "¿QUÉ TE GUSTARÍA DECIRLE A LA PERSONA QUE ERAS HACE CINCO AÑOS?",
          "¿QUÉ ES ALGO QUE EXTRAÑAS DE CUANDO ERAS MÁS PEQUEÑO?",
          "¿CUÁL FUE LA ÚLTIMA VEZ QUE HICISTE ALGO POR PRIMERA VEZ?",
          "¿QUÉ MOMENTO DE TU VIDA TE GUSTARÍA PODER GUARDAR PARA SIEMPRE?"
        ]
      },

      relaciones: {
        questions: [
          {
            text:
              "¿CREES QUE HAY PERSONAS QUE LLEGAN A TU VIDA EN EL MOMENTO EQUIVOCADO?",
            file: "RELACIONES_01_FINAL.mp3",
            answers: [
              "SÍ",
              "NO",
              "CREO QUE TODO PASA POR ALGO"
            ]
          },
          {
            text:
              "¿Y CREES QUE ALGUNAS MERECEN UNA SEGUNDA OPORTUNIDAD?",
            file: "RELACIONES_02_FINAL.mp3",
            answers: [
              "SÍ",
              "NO",
              "NO SIEMPRE"
            ]
          }
        ],

        deep: [
          "¿QUÉ ES ALGO QUE NUNCA LE CONFESASTE A ALGUIEN QUE QUISISTE?",
          "¿QUÉ LE DIRÍAS A ALGUIEN SI PUDIERAS VOLVER A VERLO?",
          "¿HAY ALGO QUE TE GUSTARÍA DECIR Y NUNCA ENCONTRASTE EL MOMENTO?",
          "¿QUÉ PERSONA TE CAMBIÓ SIN DARSE CUENTA?",
          "¿QUÉ ES ALGO QUE APRENDISTE DE ALGUIEN QUE YA NO ESTÁ EN TU VIDA?",
          "¿QUÉ MENSAJE ESCRIBISTE Y NUNCA ENVIASTE?",
          "¿CUÁL FUE LA ÚLTIMA VEZ QUE ALGUIEN TE HIZO SENTIR VERDADERAMENTE QUERIDO?"
        ]
      },

      existencia: {
        questions: [
          {
            text:
              "¿TE GUSTARÍA SABER QUÉ VA A PASAR CONTIGO DENTRO DE DIEZ AÑOS?",
            file: "EXISTENCIA_01_FINAL.mp3",
            answers: [
              "SÍ",
              "NO",
              "ME DARÍA MIEDO"
            ]
          },
          {
            text:
              "¿CREES QUE TU YO DE HACE CINCO AÑOS ESTARÍA SORPRENDIDO DE VERTE HOY?",
            file: "EXISTENCIA_02_FINAL.mp3",
            answers: [
              "MUCHO",
              "NO TANTO",
              "NO SÉ"
            ]
          }
        ],

        deep: [
          "¿QUÉ ES ALGO DE TI QUE TODAVÍA NO ENTIENDES?",
          "¿QUÉ TE GUSTARÍA DECIRLE A TU YO DEL FUTURO?",
          "¿QUÉ ES ALGO QUE TE DA MIEDO QUE NUNCA SUCEDA?",
          "¿CUÁNDO FUE LA ÚLTIMA VEZ QUE SENTISTE QUE ESTABAS EXACTAMENTE DONDE DEBÍAS ESTAR?",
          "¿QUÉ TE GUSTARÍA HACER SI NO TUVIERAS MIEDO?",
          "¿QUÉ TE GUSTARÍA QUE ALGUIEN ENTENDIERA DE TI?",
          "¿QUÉ LE DIRÍAS A ALGUIEN QUE SIENTE QUE SE ESTÁ QUEDANDO ATRÁS?"
        ]
      }
    };

    // ==================================
    // ESTILOS
    // ==================================

    const style = document.createElement("style");

    style.id = "uxs-questions-styles";

    style.textContent = `
      #uxs-main.uxs-questions-pending
      #uxs-recording {
        display: none !important;
      }

      #uxs-answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 11px;
        width: min(90vw, 400px);
        margin: 8px auto;
      }

      .uxs-answer {
        width: 100%;
        min-height: 46px;
        padding: 12px 18px;
        background: transparent;
        border: 1px solid rgba(255,255,255,.32);
        color: #fff;
        font-family: monospace;
        font-size: 12px;
        letter-spacing: 1.5px;
        line-height: 1.6;
        cursor: pointer;
        transition: background .25s, opacity .25s;
        animation: uxs-answer-in .45s ease both;
      }

      .uxs-answer:hover,
      .uxs-answer:focus-visible {
        background: rgba(255,255,255,.09);
        border-color: #fff;
      }

      .uxs-answer.uxs-selected {
        border-color: #fff;
        background: rgba(255,255,255,.15);
      }

      #uxs-answer-container button:disabled {
        cursor: default;
      }

      #uxs-question-note {
        color: #999;
        font-family: monospace;
        font-size: 10px;
        letter-spacing: 1px;
        line-height: 1.8;
        text-align: center;
        max-width: 400px;
        margin: 0 auto;
      }

      #uxs-voice001-subtitles {
        width: min(90vw, 680px);
        min-height: 75px;
      }

      @keyframes uxs-answer-in {
        from {
          opacity: 0;
          transform: translateY(7px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;

    if (!document.getElementById(style.id)) {
      document.head.appendChild(style);
    }

    // ==================================
    // INTERFAZ
    // ==================================

    const answersContainer =
      document.createElement("div");

    answersContainer.id = "uxs-answer-container";

    subtitle.insertAdjacentElement(
      "afterend",
      answersContainer
    );

    const note = document.createElement("p");
    note.id = "uxs-question-note";

    answersContainer.insertAdjacentElement(
      "afterend",
      note
    );

    // ==================================
    // REPRODUCTOR DE PREGUNTAS
    // ==================================
    // Reutilizamos el ID que reconoce
    // nuestro visualizador de VOICE 001.
    //
    // Solo lo creamos después de terminar
    // la apertura, para que no compitan.

    let player = null;

    function preparePlayer() {
      const openingPlayer =
        document.getElementById("uxs-voice001-player");

      if (openingPlayer) {
        // La apertura ya terminó cuando
        // se llama esta función.
        openingPlayer.id = "uxs-opening-player";
      }

      player = document.createElement("audio");

      player.id = "uxs-voice001-player";
      player.crossOrigin = "anonymous";
      player.preload = "auto";
      player.playsInline = true;
      player.style.display = "none";

      main.appendChild(player);
    }

    // ==================================
    // ESTADO DE LA SESIÓN
    // ==================================

    const pathNames = Object.keys(paths);

    const selectedName =
      pathNames[
        Math.floor(Math.random() * pathNames.length)
      ];

    const selectedPath = paths[selectedName];

    const session = {
      path: selectedName,
      answers: [],
      deepQuestion: null
    };

    window.UXSSession = session;

    let questionIndex = 0;
    let running = false;
    let completed = false;
    let dialogueStarted = false;

    // ==================================
    // UTILIDADES
    // ==================================

    function sleep(ms) {
      return new Promise(resolve =>
        setTimeout(resolve, ms)
      );
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    // ==================================
    // SUBTÍTULOS BASADOS EN AUDIO
    // ==================================
    // Escritura con variación natural.
    // audio.currentTime controla el avance.
    //
    // Estos son tiempos aproximados;
    // los marcadores fonéticos exactos
    // se pueden afinar después.

    function makeCaptionTimeline(text, duration) {
      const words = text.trim().split(/\s+/);

      const weights = words.map(word => {
        let weight = Math.max(
          0.38,
          word.length * 0.10
        );

        if (/[,.]/.test(word)) weight += 0.15;
        if (/[?]/.test(word)) weight += 0.22;

        return weight;
      });

      const total = weights.reduce(
        (sum, weight) => sum + weight,
        0
      );

      const available = duration * 0.91;
      let position = Math.min(0.12, duration * 0.04);

      return words.map((word, index) => {
        const span = available * weights[index] / total;

        const item = {
          text: word,
          start: position,
          end: position + span
        };

        position += span;

        return item;
      });
    }

    function renderCaption(text, cursor) {
      subtitle.textContent = text;

      if (cursor && text) {
        const marker = document.createElement("span");

        marker.className = "uxs-cursor";
        marker.setAttribute("aria-hidden", "true");

        subtitle.appendChild(marker);
      }
    }

    function captionAt(time, timeline) {
      const result = [];

      let typing = false;

      for (const word of timeline) {
        if (time < word.start) {
          break;
        }

        if (time >= word.end) {
          result.push(word.text);
          continue;
        }

        const progress = clamp(
          (time - word.start) /
            Math.max(0.01, word.end - word.start),
          0,
          1
        );

        // Curva rápida al inicio de palabra,
        // más suave hacia el final.
        const eased = 1 - Math.pow(1 - progress, 2);

        const count = Math.max(
          1,
          Math.ceil(eased * word.text.length)
        );

        result.push(word.text.slice(0, count));
        typing = true;

        break;
      }

      return {
        text: result.join(" "),
        typing
      };
    }

    // ==================================
    // REPRODUCCIÓN SINCRONIZADA
    // ==================================

    function speak(text, filename) {
      return new Promise(resolve => {
        const url = audioURL(filename);

        player.pause();
        player.src = url;
        player.load();

        let done = false;
        let frame = null;
        let timeline = [];
        let duration = 0;

        let lastText = null;
        let lastTyping = null;

        function update() {
          if (done) return;

          const result = captionAt(
            player.currentTime,
            timeline
          );

          if (
            result.text !== lastText ||
            result.typing !== lastTyping
          ) {
            renderCaption(result.text, result.typing);
            lastText = result.text;
            lastTyping = result.typing;
          }

          frame = requestAnimationFrame(update);
        }

        function cleanup() {
          if (frame !== null) {
            cancelAnimationFrame(frame);
            frame = null;
          }

          player.removeEventListener(
            "loadedmetadata",
            onMetadata
          );

          player.removeEventListener(
            "ended",
            onEnded
          );

          player.removeEventListener(
            "error",
            onError
          );
        }

        function finish(success) {
          if (done) return;
          done = true;

          cleanup();

          if (success) {
            renderCaption(text, false);
          }

          resolve(success);
        }

        function onMetadata() {
          duration = player.duration;

          if (Number.isFinite(duration) &&
              duration > 0) {
            timeline = makeCaptionTimeline(
              text,
              duration
            );
          }
        }

        function onEnded() {
          finish(true);
        }

        function onError() {
          console.error(
            "UXS: audio no disponible:",
            url
          );
          finish(false);
        }

        player.addEventListener(
          "loadedmetadata",
          onMetadata
        );

        player.addEventListener(
          "ended",
          onEnded
        );

        player.addEventListener(
          "error",
          onError
        );

        // Reintentar solo cuando realmente
        // lo solicite un navegador bloqueado.

        async function tryPlay() {
          try {
            await player.play();

            answersContainer.innerHTML = "";
            note.textContent = "";

            if (!done && frame === null) {
              update();
            }
          } catch (error) {
            if (done) return;

            answersContainer.innerHTML = "";

            const retry =
              document.createElement("button");

            retry.className = "uxs-answer";
            retry.textContent =
              error.name === "NotAllowedError"
                ? "ESCUCHAR"
                : "REINTENTAR AUDIO";

            retry.addEventListener(
              "click",
              () => {
                retry.disabled = true;
                tryPlay();
              },
              { once: true }
            );

            const skip =
              document.createElement("button");

            skip.className = "uxs-answer";
            skip.textContent =
              "CONTINUAR SIN AUDIO";

            skip.addEventListener(
              "click",
              () => {
                player.pause();
                renderCaption(text, false);
                finish(true);
              },
              { once: true }
            );

            answersContainer.appendChild(retry);
            answersContainer.appendChild(skip);

            note.textContent =
              "EL NAVEGADOR NO PUDO INICIAR EL AUDIO.";
          }
        }

        // Preparar la primera pantalla
        renderCaption("", false);
        answersContainer.innerHTML = "";
        note.textContent = "";

        tryPlay();
      });
    }

    // ==================================
    // RESPUESTAS
    // ==================================

    function showAnswers(options) {
      answersContainer.innerHTML = "";

      options.forEach((answer, index) => {
        const button =
          document.createElement("button");

        button.type = "button";
        button.className = "uxs-answer";
        button.textContent = answer;

        button.style.animationDelay =
          `${index * 0.11}s`;

        button.addEventListener(
          "click",
          () => chooseAnswer(answer, button)
        );

        answersContainer.appendChild(button);
      });
    }

    async function chooseAnswer(answer, button) {
      if (running || completed) return;

      running = true;

      const current =
        selectedPath.questions[questionIndex];

      session.answers.push({
        question: current.text,
        answer
      });

      const buttons =
        answersContainer.querySelectorAll(
          "button"
        );

      buttons.forEach(item => {
        item.disabled = true;
        item.style.opacity =
          item === button ? "1" : "0.2";
      });

      button.classList.add("uxs-selected");

      await sleep(850);

      answersContainer.innerHTML = "";
      subtitle.textContent = "";

      await sleep(500);

      questionIndex++;

      if (questionIndex < 2) {
        await showQuestion();
      } else {
        await showDeepQuestion();
      }

      running = false;
    }

    // ==================================
    // PREGUNTA CERRADA
    // ==================================

    async function showQuestion() {
      const question =
        selectedPath.questions[questionIndex];

      const played = await speak(
        question.text,
        question.file
      );

      if (played) {
        await sleep(480);
        showAnswers(question.answers);
      }
    }

    // ==================================
    // PREGUNTA PROFUNDA
    // ==================================

    async function showDeepQuestion() {
      const bank = selectedPath.deep;

      const index =
        Math.floor(Math.random() * bank.length);

      const deepQuestion = bank[index];

      const number =
        String(index + 1).padStart(2, "0");

      const file =
        selectedName.toUpperCase() +
        "_PROFUNDA_" +
        number +
        "_FINAL.mp3";

      session.deepQuestion = deepQuestion;

      await sleep(750);

      const played = await speak(
        deepQuestion,
        file
      );

      if (!played) return;

      // El ente termina de pronunciar la
      // pregunta antes de mostrar HABLAR.

      await sleep(700);

      completed = true;

      main.classList.remove(
        "uxs-questions-pending"
      );

      recording.style.display = "";

      note.textContent =
        "PODRÁS RESPONDER CON TU VOZ.";

      main.dispatchEvent(
        new CustomEvent(
          "uxs:deep-question-ready",
          {
            bubbles: true,
            detail: {
              path: selectedName,
              question: deepQuestion,
              file
            }
          }
        )
      );
    }

    // ==================================
    // PUENTE NARRATIVO
    // ==================================

    async function playBridge() {
      const bridgeText =
        "QUÉ RARO. NO SÉ NADA DE TI. " +
        "BUENO, CASI NADA. " +
        "¿PUEDO PREGUNTARTE ALGO?";

      const played = await speak(
        bridgeText,
        "PUENTE_V2.mp3"
      );

      if (!played) return false;

      await sleep(1000);

      return true;
    }

    // ==================================
    // COMIENZO DESPUÉS DE LA APERTURA
    // ==================================

    async function begin() {
      if (dialogueStarted) return;

      dialogueStarted = true;
      running = true;

      await sleep(650);

      preparePlayer();

      const bridgePlayed = await playBridge();

      if (!bridgePlayed) {
        running = false;
        return;
      }

      await showQuestion();

      running = false;
    }

    main.addEventListener(
      "uxs:opening-ended",
      begin,
      { once: true }
    );

    console.log(
      "UXS VOICE 001 — 29 Audio Dialogue Ready"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();
